import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { CandidacyScoreChange, HttpResponse } from "@/types";

export function useGetCandidacyScoreChanges({
  candidacyId,
}: {
  candidacyId: string;
}) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: [
      "candidacy_score_changes",
      currentCompanyId,
      currentJobId,
      candidacyId,
    ],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/candidacy_score_changes`;
      const res = await httpClient.get<
        CandidacyScoreChange[],
        HttpResponse<CandidacyScoreChange[]>
      >(path);
      return res.data;
    },
  });
}
